import React from 'react';

const SliderLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48px"
      height="48px"
      viewBox="0 0 48 48"
      version="1.1"
    >
      <g
        id="icon-slider-left-caret--48x48"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <polyline
          id="Path"
          stroke="#F2F5F8"
          transform="translate(27.000000, 24.000000) rotate(-225.000000) translate(-27.000000, -24.000000) "
          points="37 14 37 34 17 34"
        />
      </g>
    </svg>
  );
};

export default SliderLeftIcon;
